import React from 'react'
import ReportHeader from '../../../common/ReportHeader'
import { Box, Typography } from '@mui/material'

const TrackTopupDetails = ({ topUpData = null }) => {
    if (!topUpData) return null

    const columnDef = [
        { label: "Franchisee Code", value: topUpData?.FranchiseCode || '' },
        { label: "Franchisee Name", value: topUpData?.FranchiseName || '' },
        { label: "Bus Station Name", value: topUpData?.BusStation || '' },
        { label: "Depot Name", value: topUpData?.DepoName || '' },
        { label: "Division Name", value: topUpData?.DivisionName || '' },
        { label: "Corporation Name", value: topUpData?.CorporationName || '' },
        { label: "IP Address", value: topUpData?.IPAdress || '' },
        { label: "Remarks", value: topUpData?.Remarks || '' },
        { label: "Receipt No/Date", value: topUpData?.ReceiptNoDate || '' },
    ]

    const columnDef1 = [
        { label: "OB Reference No.", value: topUpData?.OBRefNo || '' },
        { label: "Ticket No.", value: topUpData?.TicketNo || '' },
        { label: "Top Up Created  Date", value: topUpData?.RechargeDate || '' },
        { label: "Top Up Amount", value: topUpData?.TopUpAmount ?? '' },
        { label: "Payment Mode", value: topUpData?.TopUpPaymentMode || '' },
        { label: "PG Txn. Status", value: topUpData?.PGtxnStatus || '' },
        { label: "PG Txn. Id", value: topUpData?.PGtxnID || '' },
        { label: "Topup Status", value: topUpData?.TopUpStatus || '' },
    ]

    const labelStyle = {
        fontWeight: "500",
        fontStyle: "Medium",
        fontSize: "14px",
        lineHeight: "20px",
        letterSpacing: "2%",
        color: '#202020'
    }

    const getStatusStyle = (value) => {
        const status = (value || '').toString().toUpperCase()
        if (status === 'SUCCESS') {
            return {
                fontWeight: "700",
                fontSize: "18px",
                lineHeight: "20px",
                letterSpacing: "2%",
                textTransform: "uppercase",
                color: '#3C763C'
            }
        }
        if (status === 'FAILED' || status === 'FAILURE') {
            return {
                fontWeight: "700",
                fontSize: "18px",
                lineHeight: "20px",
                letterSpacing: "2%",
                textTransform: "uppercase",
                color: '#A94442'
            }
        }
        return {}
    }

    return (
        <Box sx={{ padding: '12px 16px' }}>
            <ReportHeader mainHeaderName={"Top up details"} headerName={""} mainMenuOpen={false} />
            <Box sx={{ display: 'flex', padding: '20px 16px', gap: '40px', border: ' 1px solid rgba(0, 0, 0, 0.1019607843)' }}>
                <Box sx={{ width: '50%', borderRight: "1px solid #004F9E", display: 'flex', flexDirection: 'column', gap: "12px" }}>
                    {columnDef.map((obj, index) => (
                        <Box key={`left-${index}`} sx={{ display: 'flex', gap: '8px', alignItems: 'start' }}>
                            <Typography sx={{ ...labelStyle, width: '40%' }}>{obj.label}</Typography>
                            <Typography sx={{ ...labelStyle }}>:</Typography>
                            <Typography sx={{ ...labelStyle }}>{obj.value}</Typography>
                        </Box>
                    ))}
                </Box>
                <Box sx={{ width: '50%', display: 'flex', flexDirection: 'column', gap: "12px" }}>
                    {columnDef1.map((obj, index) => (
                        <Box key={`right-${index}`} sx={{ display: 'flex', gap: '8px', alignItems: 'start' }}>
                            <Typography sx={{ ...labelStyle, width: '40%' }}>{obj.label}</Typography>
                            <Typography sx={{ ...labelStyle }}>:</Typography>
                            <Typography sx={{
                                ...labelStyle,
                                ...(['PG Txn. Status', 'Topup Status'].includes(obj.label) ? getStatusStyle(obj.value) : {})
                            }}>
                                {obj.value}
                            </Typography>
                        </Box>
                    ))}
                </Box>
            </Box>
        </Box>
    )
}

export default TrackTopupDetails
